var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#7C84E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4 v22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4 v22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5 l5 20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLibrary);
export default __webpack_public_path__ + "static/media/nav-library.efb8b051958c64d406efd1a87ab97ced.svg";
export { ForwardRef as ReactComponent };